module.exports = __webpack_public_path__ + "img/savannah-pyles.9e093aa1.jpg";